import { Component, OnInit, Inject, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute, Data, Params } from "@angular/router";
import { AuthenticationService } from "@services/authentication.service";
import { CommonService } from '@services/app.common.service';
import { HttpClient } from '@angular/common/http';
import { StatusCode, SSOType } from '../_shared/_enums/Common';
import { FormConfigModel } from '../_shared/_models/Layout/FormConfig';
import { RoleAccessService } from '@services/role.access.service';
import { DynamicScriptLoaderService } from '@services/dynamicScriptLoaderService';
import { JTUserIdleService } from '../_shared/userIdle/user-idle.service';
import { ResponseToken } from './Interface/response-token.interface';
declare var gtag: Function;

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})

export class LoginComponent implements OnInit {
  user = {
    userName: '',
    password: ''
  };
  public modalConfig = {} as FormConfigModel;
  public forcefullyStop: boolean = false;
  public showLoader = false;
  data = [];
  public _http;
  public _baseUrl;
  public StatusCode = StatusCode;
  public ssoConfig;
  public forgeryToken: string = '';
  public loginMessage: string = '';
  public isJTGO = false;
  public isIEBrowser = false;
  public isOlderEdgeBrowser = false;
  public tokenResponse: ResponseToken;
  public token :string = '';
  public showMobileLink: boolean = false;
  public mobileSiteUrl: string = '';
  public copyRight: string = '';
  shouldCheckBreachedPassword: boolean = false;
  constructor(private router: Router, public common: CommonService, public authService: AuthenticationService, http: HttpClient, @Inject('BASE_URL') baseUrl: string, private renderer: Renderer2, public roleService: RoleAccessService, public dynamicScripts: DynamicScriptLoaderService, private route: ActivatedRoute, private userIdle: JTUserIdleService) {
    this.user = {
      userName: '',
      password: ''
    };
    this.route.queryParams.subscribe((params: Params) => {
      this.forcefullyStop = this.common.getBoolean(params['forcefullyStop']);
    });
    this.tokenResponse = {} as ResponseToken;
    this._http = http;
    this._baseUrl = baseUrl;
    this.renderer.removeClass(document.body, 'body-class');
    this.renderer.addClass(document.body, 'body-class-login');
    this.ssoConfig = this.common.ssoConfig;
    if (this.router.url !== '/Login1') {
      if (this.ssoConfig != undefined) {
        if (this.ssoConfig.SingleSignOn == 'Yes' && this.ssoConfig.SingleSignOn_Type == SSOType.Microsoft && this.ssoConfig.ForceSingleSignIn_Microsoft == 'Y') {
          this.SSOLogin();
        } else if (this.ssoConfig.SingleSignOn_Type == SSOType.Cas) {
          this.CASLogin();
        }
        else if (this.ssoConfig.SingleSignOn_Type == SSOType.Okta && !this.forcefullyStop) {
          this.OktaLogin();
        }
      }
      this.ClearSSOLogoutParams();
    }
  }

  ngOnInit() {

    ;
    this.userIdle.stopWatching();

    this.route.data.subscribe((data: Data) => {
      this.tokenResponse = data['tokenAnonymousResponse'];
      this.token = `Bearer ${this.tokenResponse.resultData}`;
    });
    this.copyRight = "1998 - " + new Date().getFullYear() + this.common.GetTranslation('Login.Footer')

    this.route.data.subscribe((data: Data) => {

      if (data.tokenResponse) {
        this.forgeryToken = data.tokenResponse.resultData;
        this.common.SetLocalStorage('forgeryToken', this.forgeryToken);
      }
    });
    this.modalConfig.hideDefaultAction = true;
    this.modalConfig.hideCard = false;
    this.common.RemoveAccessToken();
    this.common.RemoveLocalStorage('jt_password_compromised');
    this.ssoConfig = this.common.ssoConfig;
    this.loadGoogleAnalytics();
    const clientSetting = this.common.getClientSettings();
    this.loginMessage = clientSetting.LoginMessage;
    this.isJTGO = clientSetting.IsJTGO;
    this.isIEBrowser = this.common.IsIEBrowser();


    const browserVersion = parseInt(this.common.getBrowserVersion());
    this.isOlderEdgeBrowser = this.common.IsEdgeBrowser() && browserVersion < 40;
    this.LoadLoginConfiguration();
  }

  getTranslationFile() {
    this.common.PostData('Translation/GetTranslationFile', navigator.language).then(data => {
      this.data = data;
    });
  }


  private LoadLoginConfiguration():void {
    var $this = this;
    this.common.GetData(this.common.ApiUrls.AnonymousUser.LoadLoginConfiguration, false, this.token).then(function (data) {
      if (data.status == StatusCode.OK) {
        if (data.resultData.showMobileLink == 1) {
          $this.showMobileLink = true;
          $this.mobileSiteUrl = data.resultData.mobileSiteUrl;
        }
        $this.shouldCheckBreachedPassword = data?.resultData?.configEnableBreachedPasswordCheck;
      }
    });
  }



  login() {
    ;
    this.common.Loader.show();
    const $this = this;
    this.authService.login(this.user.userName, this.user.password, null, this.shouldCheckBreachedPassword);
  }

  public redirectToUrl():void {
    window.open(this._baseUrl + this.common.ApiUrls.ForgotPassword.ForgotPasswordURl, '_blank');
  }

  public goToMobile(): void {
    window.open(this.mobileSiteUrl, '_blank');
  }

  public SSOLogin() {
    window.location.href = this.common.ApiUrls.Login.ApiSSOLogin;
    return false;
  }
  public CASLogin() {
    window.location.href = this.common.ApiUrls.Login.CASLogin;
    return false;
  }
  public OktaLogin() {
    window.location.href = this.common.ApiUrls.Login.OktaLogin;
    return false;
  }

  public loadGoogleAnalytics() {
    try {


      this.dynamicScripts.load('gaTag').then(data => {
        const gaScript = document.createElement('script');
        gaScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'UA-142400835-1', {
      'custom_map': { 'dimension1': 'client' }
    });
      `;
        document.head.appendChild(gaScript);

        const settings = this.common.getSettings();
        const clientSetting = settings.ClientSetting;
        let clientName = 'jtdemo';
        if (clientSetting != null && clientSetting != '' && clientSetting.ClientName != '') {
          clientName = clientSetting.ClientName;
        }
        gtag('event', 'any_event_name', { 'client': clientName });

      });
    } catch (ex) {
      console.error('Error appending google analytics');
      console.error(ex);
    }
  }

  public ClearSSOLogoutParams() {
    var snapshot = this.route.snapshot;
    const params = { ...snapshot.queryParams };
    delete params.forcefullyStop;
    this.router.navigate([], { queryParams: params });
    this.forcefullyStop = false;
  }
}
